<template>
  <div class='app-container'>
    <el-card class='box-card'>
      <div slot='header' class='clearfix'>
        <span>网关升级</span>
      </div>
      <el-form :label-width='formLabelWidth' ref='form' :rules='rules' :model='form'>

        <el-form-item label='网关编号' prop='cabinet_id'>
          <el-input t v-model='form.cabinet_id' placeholder='20202120' style='width:50%;'></el-input>
        </el-form-item>
        <el-form-item label='FTP IP地址' prop='server_ip'>
          <el-input t v-model='form.server_ip' placeholder='192.168.1.100' style='width:50%;'></el-input>
        </el-form-item>

        <el-form-item label='FTP端口' prop='port'>
          <el-input t v-model='form.port' placeholder='21' style='width:50%;'></el-input>
        </el-form-item>

        <el-form-item label='FTP登录账号' prop='user_name'>
          <el-input t v-model='form.user_name' placeholder='test' style='width:50%;'></el-input>
        </el-form-item>

        <el-form-item label='FTP登录密码' prop='password'>
          <el-input t v-model='form.password' placeholder='123456' style='width:50%;'></el-input>
        </el-form-item>

        <el-form-item label='文件路径' prop='file'>
          <el-input t v-model='form.file' placeholder='/home/baymax/ftp/ChargeCabinet/ChargeCabinet.zip' style='width:50%;'></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type='primary' @click='sendCmd'>确认升级</el-button>
          <el-button @click='reset'>重置</el-button>
        </el-form-item>

      </el-form>
    </el-card>
  </div>
</template>
<script>
import { gateway } from '@/api/admin.js'


export default {
  data() {
    return {
      formLabelWidth: '120px',
      form: {
        cabinet_id: null,
        server_ip: '',
        port: '',
        user_name: '',
        password: '',
        file: '',
      },
      rules: {
        cabinet_id: [
          { required: true, message: '请输入网关编号', trigger: 'blur' }
        ],
        server_ip: [
          { required: true, message: '请输入FTP IP地址', trigger: 'blur' }
        ],
        port: [
          { required: true, message: '请输入FTP端口', trigger: 'blur' }
        ],
        user_name: [
          { required: true, message: '请输入FTP登录账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入FTP登录密码', trigger: 'blur' }
        ],
        file: [
          { required: true, message: '请输入文件路径', trigger: 'blur' }
        ]
      },
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {
    this.id = this.$route.query.id
  },
  methods: {
    //重置输入框
    reset() {
      this.form = {
        cabinet_id: null,
        server_ip: '',
        port: '',
        user_name: '',
        password: '',
        file: '',
      }
      this.$refs['form'].resetFields()
      this.$refs['form'].clearValidate()
    },
    sendCmd() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.cmdForm = {
            req_id: 'upgrade',
            cabinet_id: parseInt(this.form.cabinet_id),
            type: 0x11,
            data: {
              server_ip:this.form.server_ip,
              port:this.form.port,
              user_name:this.form.user_name,
              password:this.form.password,
              file:this.form.file,
            }
          }
          //柜控板-
          let str = JSON.stringify(this.cmdForm)
          //开灯-   var form = { req_id: 'test', cabinet_id: parseInt(row.id), type: 0x01, data: { cmd: 'bo', param: 0x01, param2: 0x01 } }
          gateway({
            func: 'set_cabinet_ctrl',
            params: str
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')
            } else {
              this.$message.error('操作失败：'+res.msg)
            }
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>

<style scoped>

</style>